import Reveal from "@/components/base/Reveal";
import { detailedPlans } from "@/mocks/hospedagem";

export default function HostingPlans() {
  return (
    <section id="planos" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-secondary-700">
              <i className="ri-price-tag-3-line" aria-hidden="true"></i>
              Planos de hospedagem
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Escolha o plano ideal para o seu projeto.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Todos os planos contam com infraestrutura profissional, e-mail no domínio da empresa e
              suporte especializado. Os recursos podem ser ajustados conforme a sua necessidade.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {detailedPlans.map((plan, index) => (
            <Reveal key={plan.name} delay={index * 70} className="h-full">
              <article
                className={`relative flex h-full flex-col rounded-xl border bg-background-50 p-6 transition-colors ${
                  plan.highlighted
                    ? "border-primary-300"
                    : "border-background-200 hover:border-primary-200"
                }`}
              >
                {plan.badge ? (
                  <span className="absolute -top-3 left-6 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-background-50">
                    <i className="ri-star-line" aria-hidden="true"></i>
                    {plan.badge}
                  </span>
                ) : null}

                <h3 className="font-heading text-lg font-semibold text-foreground-950">{plan.name}</h3>
                <p className="mt-2 min-h-[40px] text-sm text-foreground-600">{plan.audience}</p>

                <div className="mt-5 flex items-end gap-1">
                  <span className="text-sm font-medium text-foreground-500">R$</span>
                  <span className="font-heading text-4xl font-bold text-foreground-950">
                    {plan.price}
                  </span>
                  <span className="mb-1 text-sm text-foreground-500">/mês</span>
                </div>

                <p className="mt-4 text-sm leading-relaxed text-foreground-600">{plan.summary}</p>

                <ul className="mt-6 flex flex-1 flex-col gap-3">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line mt-0.5 text-secondary-600" aria-hidden="true"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <div className="mt-7 flex flex-col gap-2">
                  <a
                    href={plan.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-3 text-sm font-semibold transition-colors ${
                      plan.highlighted
                        ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                        : "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                    }`}
                  >
                    Contratar agora
                  </a>
                  <a
                    href="#comparativo"
                    className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
                  >
                    Comparar planos
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}